import {Box} from '@mui/material';
import {Outlet, useLocation} from 'react-router-dom';
import TabMenu from 'src/components/TabMenu';
import TabletIcon from '@mui/icons-material/Tablet';
import SensorDoorOutlinedIcon from '@mui/icons-material/SensorDoorOutlined';
import {useMemo} from 'react';

export default function DeviceLayout() {
  const location = useLocation();
  const tabs = useMemo(() => {
    return [
      {to: '/devices', label: 'Devices', icon: <TabletIcon />},
      {to: '/devices/accessGroup', label: 'Access Group', icon: <SensorDoorOutlinedIcon />},
    ];
  }, []);
  const showTab = tabs.some(tab => tab.to === location.pathname);

  return (
    <>
      {showTab && <TabMenu tabs={tabs} />}
      <Box sx={{paddingY: 2}}>
        <Outlet />
      </Box>
    </>
  );
}
